// Switch component button index
export const SWITCH_BUTTON_INDEX = 1;
